module.exports = __webpack_public_path__ + "static/img/Bachelor_010794.2e8fdc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010794.jpg
// module id = 249
// module chunks = 0